export async function teamProjectsQuery({ client, team }) {
  const { data } = await client.get(`teams/${team}/projects/`);
  return data;
}

export async function projectQuery({ client, teamId, projectId }) {
  const { data } = await client.get(`teams/${teamId}/projects/${projectId}`);
  return data;
}
